import Hero from 'components/hero';
import Layout from 'components/layout';
import SEO from 'components/seo';
import SwitchTheme from 'components/switch-theme';
import { Section } from 'components/ui/section';
import { SectionWrapper } from 'components/ui/section-wrapper';
import { Text } from 'components/ui/text';
import { useIsLoggedIn } from 'hooks/use-is-loggedIn';
import { NextPage } from 'next';
import Head from 'next/head';
import Link from 'next/link';
import { backgroundImages } from 'utils/config';
import APP_ROUTES from 'utils/routes';

const ChooseYourPlan: NextPage = () => {
  const isLoggedIn = useIsLoggedIn();

  return (
    <>
      <SEO
        title=''
        description='What will you do if there is a bushfire? Create a bushfire survival plan in 15 minutes or less. Download the app or fill in the survey on the site.'
      />
      <Head>
        <title>My Bushfire Plan WA: Prepare for an Emergency - DFES</title>
      </Head>
      <Layout mainBackground={backgroundImages.hero}>
        <Hero subheading='Choose your plan' smallTitle>
          <Text size='small'>
            A bushfire plan can help keep you and your family safe. Create one
            now in under 15 minutes.
          </Text>
        </Hero>
        {!isLoggedIn ? (
          <SwitchTheme to='dark'>
            <Section>
              <SectionWrapper noPadding>
                <Text centerText>
                  Already have an account?{' '}
                  <Link href={APP_ROUTES.users.signIn}>
                    <a>Login</a>
                  </Link>
                </Text>
              </SectionWrapper>
            </Section>
          </SwitchTheme>
        ) : (
          <SwitchTheme to='dark'>
            <Section>
              <SectionWrapper noPadding>
                <Text centerText>
                  Already have a plan? Update an existing plan&nbsp;
                  <Link href={APP_ROUTES.account}>
                    <a>here</a>
                  </Link>
                </Text>
              </SectionWrapper>
            </Section>
          </SwitchTheme>
        )}
      </Layout>
    </>
  );
};

export default ChooseYourPlan;
